import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import Logo from "../Logo";
import { NavItems, SidebarFooter } from "./Sidebar";

export default function MobileDrawer({ open, onClose }) {
    return (
        <AnimatePresence>
            {open && (
                <>
                    <motion.div
                        data-testid="mobile-drawer-backdrop"
                        className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm lg:hidden"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={onClose}
                    />
                    <motion.aside
                        data-testid="mobile-drawer"
                        className="fixed inset-y-0 left-0 z-50 flex w-72 flex-col border-r border-white/10 bg-[#0C0E15] lg:hidden"
                        initial={{ x: "-100%" }}
                        animate={{ x: 0 }}
                        exit={{ x: "-100%" }}
                        transition={{ type: "tween", duration: 0.28, ease: "easeOut" }}
                    >
                        <div className="flex items-center justify-between border-b border-white/[0.07] px-5 py-5">
                            <div className="flex items-center gap-3">
                                <Logo size={34} testid="mobile-drawer-logo" />
                                <div>
                                    <p className="font-display text-sm font-extrabold tracking-wide text-white">
                                        EQUIPE STAFF
                                    </p>
                                    <p className="font-code text-[10px] font-medium tracking-[0.3em] text-violet-400">
                                        [EBH1]
                                    </p>
                                </div>
                            </div>
                            <button
                                data-testid="mobile-drawer-close"
                                onClick={onClose}
                                aria-label="Fechar menu"
                                className="flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 text-gray-400 transition-colors hover:bg-white/5 hover:text-white"
                            >
                                <X className="h-4 w-4" />
                            </button>
                        </div>
                        <NavItems onNavigate={onClose} />
                        <SidebarFooter />
                    </motion.aside>
                </>
            )}
        </AnimatePresence>
    );
}
